import { get } from 'lodash'

function IssuerDisplay(record) {
  const issuer = get(record.issuer_period_audience, 'issuer', [])

  return `${issuer.issuer_id} | ${issuer.name}`
}

export default IssuerDisplay
